import {
  CreditCardFilled,
  DashboardOutlined,
  ScanOutlined,
  UserOutlined,
  UserSwitchOutlined,
  LeftOutlined,
  LeftCircleFilled,
  ContainerFilled,
  SafetyCertificateOutlined,
  BankOutlined,
  UsergroupAddOutlined,
  BarChartOutlined, // Ikon panah ke kiri
} from "@ant-design/icons";
import { Layout, Menu, Drawer, theme, Button } from "antd";
import { useContext, useState } from "react";
import { MainContext } from "./DashboardUser";
import { Link } from "react-router-dom";
import Logo from "../../../component/Logo/Logo";
import { useMediaQuery } from "react-responsive";

const { Sider } = Layout;

const Sidebar = () => {
  const { collapsed } = useContext(MainContext);
  const [drawerVisible, setDrawerVisible] = useState(false); // State untuk mengontrol visibilitas drawer
  const isMobile = useMediaQuery({ maxWidth: 768 }); // Deteksi perangkat mobile

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // Fungsi untuk menutup Drawer setelah klik menu
  const handleMenuClick = () => {
    if (isMobile) {
      setDrawerVisible(false); // Tutup Drawer jika mobile
    }
  };

  const items = [
    {
      label: "Visitor",
      key: "visitor-group",
      icon: <UserSwitchOutlined />,
      children: [
        {
          label: (
            <Link to="/user" onClick={handleMenuClick}>
              Visitor
            </Link>
          ),
          key: "dashboard",
          icon: <UserSwitchOutlined />,
        },
        {
          label: (
            <Link to="scan" onClick={handleMenuClick}>
              Scan Visitor
            </Link>
          ),
          key: "scan",
          icon: <ScanOutlined />,
        },
        {
          label: (
            <Link to="institution" onClick={handleMenuClick}>
              Institution
            </Link>
          ),
          key: "institution",
          icon: <ContainerFilled />,
        },
        {
          label: (
            <Link to="card-list" onClick={handleMenuClick}>
              Card
            </Link>
          ),
          key: "card-list",
          icon: <CreditCardFilled />,
        },
      ],
    },
    {
      label: "Patrol",
      key: "patrol-group",
      icon: <SafetyCertificateOutlined />,
      children: [
        {
          label: (
            <Link to="patrol-list" onClick={handleMenuClick}>
              Patrol
            </Link>
          ),
          key: "patrol-list",
          icon: <SafetyCertificateOutlined />,
        },
        {
          label: (
            <Link to="location-list" onClick={handleMenuClick}>
              Location
            </Link>
          ),
          key: "location-list",
          icon: <BankOutlined />,
        },
      ],
    },
    {
      label: (
        <Link to="statistic" onClick={handleMenuClick}>
          Statistic
        </Link>
      ),
      key: "statistic",
      icon: <BarChartOutlined />,
    },
    {
      label: (
        <Link to="users-list" onClick={handleMenuClick}>
          Users
        </Link>
      ),
      key: "users-list",
      icon: <UsergroupAddOutlined />,
    },
    {
      label: (
        <Link to="profile" onClick={handleMenuClick}>
          Profile
        </Link>
      ),
      key: "profile",
      icon: <UserOutlined />,
    },
  ];

  // Jika mobile, gunakan Drawer
  if (isMobile) {
    return (
      <>
        {/* Tombol untuk membuka Drawer */}
        <div
          style={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: 999,
            background: "#fff",
            padding: "8px 12px",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
          }}
          onClick={() => setDrawerVisible(true)}
        >
          ☰
        </div>

        {/* Drawer untuk tampilan mobile */}
        <Drawer
          placement="left"
          closable={false}
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={256} // Lebar drawer
        >
          {/* Header Drawer dengan logo dan tombol tutup */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 20,
              padding: "0 16px",
            }}
          >
            {/* Logo */}
            <Link to="/" className="menuItem">
              <Logo />
            </Link>

            {/* Tombol tutup dengan ikon panah ke kiri */}
            <Button
              type="text"
              icon={<LeftCircleFilled />}
              onClick={() => setDrawerVisible(false)}
              style={{
                fontSize: "18px",
                color: "#000",
                padding: 0,
              }}
            />
          </div>

          {/* Menu */}
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={items}
          />
        </Drawer>
      </>
    );
  }

  // Jika desktop, gunakan Sidebar seperti biasa
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{ background: colorBgContainer }}
    >
      {/* Header Sidebar dengan logo */}
      <div
        style={{
          textAlign: "center",
          paddingTop: 16,
          paddingBottom: 16,
        }}
      >
        <Link to="/" className="menuItem">
          <Logo
            style={{
              width: "100px", // Ukuran logo lebih besar
              height: "100px", // Proporsional dengan lebar
            }}
          />
        </Link>
      </div>

      {/* Menu */}
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["1"]}
        items={items}
      />
    </Sider>
  );
};

export default Sidebar;
